import { Application } from "@hotwired/stimulus"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// Custom :debounce action option
// Usage: data-action="input->controller#method:debounce"
// Set delay with: data-debounce-wait="300" (defaults to 300ms)
const debounceTimeouts = new WeakMap()

application.registerActionOption("debounce", ({ event, element, controller }) => {
  if (event._debounced) return true

  const wait = parseInt(element.dataset.debounceWait || "300", 10)
  const key = `${controller.identifier}-${event.type}-${element.id || element.dataset.action}`

  let timeouts = debounceTimeouts.get(controller)
  if (!timeouts) {
    timeouts = {}
    debounceTimeouts.set(controller, timeouts)
  }

  clearTimeout(timeouts[key])
  timeouts[key] = setTimeout(() => {
    delete timeouts[key]
    if (!controller.element.isConnected) return
    const debounced = new Event(event.type, { bubbles: event.bubbles })
    debounced._debounced = true
    element.dispatchEvent(debounced)
  }, wait)

  return false
})

export { application }
